import React, { Fragment, useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import { Grid, Link, CircularProgress } from '@mui/material'
import { ApiConfig, apiCall } from '../../../config/api'
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt'
interface AsnDownloadProps {
  id: number // usado para packingListId / usado en devoluciones con AsnId
  hideInfoReturnAsn?: boolean
}

export const AsnDownload: React.FC<AsnDownloadProps> = ({
  id,
  hideInfoReturnAsn
}) => {
  const [disabledLink, setDisabledLink] = useState<boolean>(false)
  const [disabledLinkProcess, setDisabledLinkProcess] = useState<boolean>(false)
  const [disabledDownloadSkusQty, setDisabledDownloadSkusQty] =
    useState<boolean>(false)
  const [processId, setProcessId] = useState<number | null>(0)

  useEffect(() => {
    handleProcessId(id)
  }, [])

  const handleProcessId = (packingListId: number) => {
    apiCall('GET', `${ApiConfig.PackingListApi}/${packingListId}`)
      .then((response: any) => {
        if (response.status === 200) {
          setProcessId(response.data.processId)
        }
      })
      .catch((message: any) => {
        console.log('message: ', message)
      })
  }

  const handleDownloadFile = () => {
    setDisabledLink(true)
    setTimeout(() => {
      apiCall('GET', `${ApiConfig.ProcessApi}/GetFile/${processId}`, {
        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200 && response.data !== null) {
            const raw = window.atob(response.data.file)
            const uInt8Array = new Uint8Array(raw.length)
            for (let i = 0; i < raw.length; ++i) {
              uInt8Array[i] = raw.charCodeAt(i)
            }
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], {
              type: response.data.mimeType
            })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', response.data.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch((message: any) => {
          console.log('message: ', message)
        })
      setDisabledLink(false)
    }, 1500)
  }

  const handleDownloadProcessFile = () => {
    setDisabledLinkProcess(true)
    setTimeout(() => {
      apiCall('GET', `${ApiConfig.ProcessApi}/GetResultFile/${processId}`, {
        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200 && response.data !== null) {
            const raw = window.atob(response.data.file)
            const uInt8Array = new Uint8Array(raw.length)
            for (let i = 0; i < raw.length; ++i) {
              uInt8Array[i] = raw.charCodeAt(i)
            }
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], {
              type: response.data.mimeType
            })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', response.data.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch((message: any) => {
          console.log('message: ', message)
        })
      setDisabledLinkProcess(false)
    }, 1500)
  }

  const handleDownloadSkusQty = () => {
    setDisabledDownloadSkusQty(true)
    setTimeout(() => {
      apiCall('GET', `${ApiConfig.AsnReturnApi}/${id}/FileExport`, {
        responseType: 'blob'
      })
        .then((response: any) => {
          if (response.status === 200 && response.data !== null) {
            const raw = window.atob(response.data.file)
            const uInt8Array = new Uint8Array(raw.length)
            for (let i = 0; i < raw.length; ++i) {
              uInt8Array[i] = raw.charCodeAt(i)
            }
            const link = document.createElement('a')
            const blob = new Blob([uInt8Array], {
              type: response.data.mimeType
            })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', response.data.name)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        })
        .catch((message: any) => {
          console.log('message: ', message)
        })
      setDisabledDownloadSkusQty(false)
    }, 1500)
  }

  return (
    <Fragment>
      <Grid
        container
        xs={12}
        sm={12}
        md={12}
        lg={12}
        spacing={1}
        style={{ paddingLeft: '20px' }}
      >
        {!hideInfoReturnAsn && (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant='body2' component='p'>
              <SystemUpdateAltIcon
                color='disabled'
                style={{ paddingRight: '10px', verticalAlign: 'middle' }}
              />
              {disabledLink ? (
                <Fragment>
                  <Link
                    style={{ cursor: 'pointer', pointerEvents: 'none' }}
                    onClick={handleDownloadFile}
                  >
                    Descargando...
                  </Link>{' '}
                  <CircularProgress size='0.9rem' />
                </Fragment>
              ) : (
                <Link
                  style={{ cursor: 'pointer' }}
                  onClick={handleDownloadFile}
                >
                  Archivo Excel Original
                </Link>
              )}
            </Typography>
          </Grid>
        )}
        {!hideInfoReturnAsn && (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant='body2' component='p'>
              <SystemUpdateAltIcon
                color='disabled'
                style={{ paddingRight: '10px', verticalAlign: 'middle' }}
              />
              {disabledLinkProcess ? (
                <Fragment>
                  <Link
                    style={{ cursor: 'pointer', pointerEvents: 'none' }}
                    onClick={handleDownloadProcessFile}
                  >
                    Descargando...
                  </Link>{' '}
                  <CircularProgress size='0.9rem' />
                </Fragment>
              ) : (
                <Link
                  style={{ cursor: 'pointer' }}
                  onClick={handleDownloadProcessFile}
                >
                  Archivo Excel Resultado de Carga
                </Link>
              )}
            </Typography>
          </Grid>
        )}

        {hideInfoReturnAsn && (
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography variant='body2' component='p'>
              <SystemUpdateAltIcon
                color='disabled'
                style={{ paddingRight: '10px', verticalAlign: 'middle' }}
              />
              {disabledDownloadSkusQty ? (
                <Fragment>
                  <Link
                    style={{ cursor: 'pointer', pointerEvents: 'none' }}
                    onClick={handleDownloadSkusQty}
                  >
                    Descargando...
                  </Link>{' '}
                  <CircularProgress size='0.9rem' />
                </Fragment>
              ) : (
                <Link
                  style={{ cursor: 'pointer' }}
                  onClick={handleDownloadSkusQty}
                >
                  Archivo Excel con productos devueltos y cantidades
                </Link>
              )}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Fragment>
  )
}
